import {
  type FlyBasketStore,
  useFlyBasketStore,
} from '@/store/fly-basket-store';
import { clsx } from 'clsx';
import type { MouseEvent } from 'react';
const selector = (state: FlyBasketStore) => ({
  handleClose: state.close,
  isOpen: state.isOpen,
});

export const Overlay = () => {
  const { handleClose, isOpen } = useFlyBasketStore(selector);

  const onOverlayClick = (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    handleClose();
  };

  return (
    <div
      className={clsx(
        'anim-pop-out absolute top-0 left-0 s:hidden h-full w-full bg-transparent backdrop-blur-0',
        isOpen && 'anim-pop-in !bg-overlay !backdrop-blur-[2px]',
      )}
      onClick={onOverlayClick}
    />
  );
};
